<template>
  <div class="about">
    <!-- banner -->
    <div class="banner-img">
        <div class="container">
            <div class="trans-box">
                <div @mouseenter="ios=true" @mouseleave="ios=false" class="trans-box1">
                </div>
                <div @mouseenter="az=true" @mouseleave="az=false" class="trans-box2">
                </div>
                <div class="ewm" v-show="ios">
                    <img src="https://static.qyjmed.com/webSite/productService/aboutApp/ios.png" alt="">
                </div>
                <div class="ewm1" v-show="az">
                    <img src="https://static.qyjmed.com/webSite/productService/aboutApp/az.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <!-- product -->
    <div class="product">
        <div class="container">
            <img src="https://static.qyjmed.com/webSite/productService/aboutApp/shuangyinhao.png" alt="">
            <p data-wow-delay="0" class="wow zoomInDown">全医佳是全国较为完善医疗设备服务市场而搭建的综合性纯服务类电商平台。借助全医佳医院设备管理服务系统为基础，依托全医佳医疗设备云服务平台为载体，对医院、服务商、医疗人提供一站式服务，进而构建联盟性行业生态链，实现海量行业信息资源的完美整合</p>
            <img src="https://static.qyjmed.com/webSite/productService/aboutApp/shuangyinhao1.png" alt="">
        </div>
    </div>
    <!-- 设备维修 -->
    <!-- <div class="server-repair">
        <div class="container">
            <div data-wow-delay="2s" class="wow bounceInLeft repair-img">
                <img width="100%" src="https://static.qyjmed.com/webSite/productService/aboutApp/server-repair-img.png" alt="">
            </div>
            <div class="repair-content">
                <h2>设备维修</h2>
                <p>医院、第三方机构通过全医佳可以实时了解最新的医疗设备信息以及采购和维修价格。全医佳已成功运营3年，维修设备高达10000万以上，2019，全医佳承载了更大更远的使命，一起砥砺奋进，御风而飞!</p>
            </div>
        </div>
    </div> -->
    <!-- 悬赏问答 -->
    <!-- <div class="raward">
        <div class="container">
            <div class="raward-content">
                <h2>悬赏问答</h2>
                <p>全医佳凝聚了一批专业工程师，高额悬赏为您解答维修过程中的问题。同时征集了众多国外内大咖驻场，可通过在线问答形式，与大咖一对一提问，第一时间为您解决疑惑。</p>
            </div>
            <div data-wow-delay="1s" class="raward-img wow bounceInRight">
                <img width="100%" src="https://static.qyjmed.com/webSite/productService/aboutApp/reward-img.png" alt="">
            </div>
        </div>
    </div> -->
    <!-- 视频学习 -->
    <!-- <div class="video-study">
        <div class="container">
            <div data-wow-delay="1s" class="study-img wow bounceInLeft">
                <img width="100%" src="https://static.qyjmed.com/webSite/productService/aboutApp/video-study-img.png" alt="">
            </div>
            <div class="study-content">
                <h2>视频学习</h2>
                <p>全医佳汇集行业内顶级专业工程师讲解故障维修过程，为您解答设备故障疑难杂症，提高维修工程师技术水准，保障维修服务专业、标准、规范。</p>
                <button v-if="!isLogin" @click="toVideo" type="button" name="button">登录后可查看视频></button>
                <button v-else @click="toVideo" type="button" name="button">查看视频></button>
            </div>
        </div>
    </div> -->
    <!-- 限时竞价 -->
    <!-- <div class="time-limit">
        <div class="container">
            <div class="limit-content">
                <h2>限时竞价</h2>
                <p>全医佳为您提供方便快捷的需求发布平台，您可以发布设备或器材的买卖需求，来自全国各地供应商在线竞价，最终选择一个满足的交易者，平台保障一切交易活动，保证交易秩序。</p>
                <button @click="toApp" type="button" name="button">DOWNLOAD APP</button>
            </div>
            <div data-wow-delay="1s" class="limit-img wow bounceInRight">
                <img width="100%" src="https://static.qyjmed.com/webSite/productService/aboutApp/time-limit-img.png" alt="">
            </div>
        </div>
    </div> -->
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
    name: 'app',
    data(){
      return {
          ios: false,
          az: false,
          isLogin: this.$store.state.login
      }
    },
    methods:{
        toVideo:function(){
            this.$router.push({path:'/video'})
        },
        toApp:function(){
            window.open('http://app.qijmed.com/')
        }
    },
    mounted() {
        var wow=new WOW({
            live: false
        })
        wow.init()
    },
    components: {
        Foot
    }
}
</script>
<style lang="scss" scoped>
    @mixin comment{
        h2{
            font-size: 40px;
            font-weight: 400;
        }
        p{
            width: 600px;
            font-size: 20px;
            line-height: 40px;
            margin-top: 40px;
            letter-spacing: 2px;

        }
    }
    .about{
        text-align: center;
        color: #606060;
        .banner-img{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/productService/aboutApp/serverBanner.png') center;
            height: 560px;
            .container{
                .trans-box{
                    padding-top: 410px;
                    text-align: left;
                    margin-left: -20px;
                    position: relative;
                    .trans-box1,.trans-box2{
                        width: 240px;
                        height: 75px;
                        margin-right: 20px;
                        cursor: pointer;
                        display: inline-block;
                    }
                    .ewm,.ewm1{
                        position: absolute;
                        top: 156px;
                        left: 0;
                        background: url('https://static.qyjmed.com/webSite/productService/aboutApp/ewm-box.png') center;
                        height: 247px;
                        width: 233px;
                        img{
                            width: 80%;
                            margin:10%;
                        }
                    }
                    .ewm1{
                        left: 260px;
                    }
                }
            }
        }
        // 介绍
        .product{
            img{
                width: 60px;
                height: 46px;
                display: inline-block;
                &:first-child{
                    vertical-align: top;
                    margin-top: 50px;
                }
                &:last-child{
                    vertical-align: bottom;
                    margin-bottom: 40px;
                }
            }
            p{
                display: inline-block;
                width: 1000px;
                margin:80px 40px;
                font-size: 20px;
                color:#606060;
                line-height: 40px;
            }
        }
        // 设备维修
        .server-repair{
            background: #F4F8FB;
            height: 460px;
            .container{
                .repair-img{
                    display: inline-block;
                    width: 400px;
                    img{
                        margin-top: 60px;
                    }
                }
                .repair-content{
                    margin:114px 100px 0;
                    display: inline-block;
                    vertical-align: top;
                    margin-top: 114px;
                    @include comment;
                }
            }
        }
        // 悬赏问答
        .raward{
            height: 650px;
            background: url("https://static.qyjmed.com/webSite/productService/aboutApp/reward-bg.png");
            .container{
                .raward-content{
                    width: 700px;
                    display: inline-block;
                    @include comment;
                    vertical-align: top;
                    margin-top: 220px;
                    p{
                        margin-left: 50px;
                    }
                }
                .raward-img{
                    width: 450px;
                    display: inline-block;
                    padding:70px 50px 0 0;
                }
            }
        }
        // 视频学习
        .video-study{
            height: 620px;
            background: url("https://static.qyjmed.com/webSite/productService/aboutApp/video-study.png");
            .container{
                .study-img{
                    display: inline-block;
                    width: 700px;
                    vertical-align: top;
                    img{
                        margin-top: 140px;
                    }
                }
                .study-content{
                    width: 500px;
                    display: inline-block;
                    @include comment;
                    margin-top: 150px;
                    p{
                        width: 500px;
                        margin-top: 40px;
                    }
                    button{
                        border: 0;
                        border-radius: 18px;
                        background: linear-gradient(to right,#7F2CF049,#F33CAB49);
                        font-size: 22px;
                        color: white;
                        text-align: center;
                        padding:12px 22px;
                        margin-top: 30px;
                        cursor: pointer;
                    }
                }
            }
        }
        // 限时竞价
        .time-limit{
            // height: 670px;
            background: url('https://static.qyjmed.com/webSite/productService/aboutApp/time-limit.png');
            .container{
                .limit-content{
                    vertical-align: top;
                    display: inline-block;
                    margin-top: 200px;
                    @include comment;
                    button{
                        font-size: 19px;
                        color: white;
                        text-align: center;
                        background: linear-gradient(to right,#52E5DE,#6CC2E7);
                        border: 0;
                        width: 247px;
                        height: 70px;
                        line-height: 70px;
                        border-radius: 35px;
                        margin-top: 82px;
                        cursor: pointer;
                    }
                }
                .limit-img{
                    width: 600px;
                    display: inline-block;
                }
            }
        }
    }
</style>
